var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"emptybg"},[_c('div',{staticClass:"emptyimg"}),_c('div',{staticClass:"empty"},[_vm._v("게시물이 없습니다 ")])])])
}]

export { render, staticRenderFns }